import { Card, CardHeader } from 'components/ui';
import { TrashIcon } from 'components/icons';
import { formatMoney, formatCurrency } from 'lib/formatters';

function QuantityStepper({ quantity, onChange }) {
  return (
    <div className="flex items-center rounded-lg border border-surface-300">
      <button
        type="button"
        onClick={() => onChange(quantity - 1)}
        className="flex h-8 w-8 items-center justify-center text-lg text-slate-600 transition hover:bg-surface-100"
        aria-label="Decrease quantity"
      >
        &minus;
      </button>
      <span className="w-8 text-center text-sm font-medium text-slate-900">{quantity}</span>
      <button
        type="button"
        onClick={() => onChange(quantity + 1)}
        className="flex h-8 w-8 items-center justify-center text-lg text-slate-600 transition hover:bg-surface-100"
        aria-label="Increase quantity"
      >
        +
      </button>
    </div>
  );
}

/** The current in-store sale: line items with quantity steppers + line totals. */
export function SaleCart({ cart, onQuantityChange, onRemove }) {
  return (
    <Card>
      <CardHeader title="Current sale" subtitle={`${cart.length} item${cart.length === 1 ? '' : 's'}`} />

      {cart.length === 0 ? (
        <p className="py-8 text-center text-sm text-slate-500">Add products to start a sale.</p>
      ) : (
        <ul className="divide-y divide-surface-200">
          {cart.map(({ item, quantity }) => {
            const name = item.vendorProductName || item.name || 'Item';
            const amount = Number(item.vendorPrice?.amount) || 0;
            return (
              <li key={item.vendorCatalogId} className="flex items-center gap-3 py-3">
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-slate-900">{name}</p>
                  <p className="text-xs text-slate-500">{formatMoney(item.vendorPrice)} each</p>
                </div>
                <QuantityStepper
                  quantity={quantity}
                  onChange={(next) => onQuantityChange(item.vendorCatalogId, next)}
                />
                <span className="w-20 text-right text-sm font-semibold text-slate-900">
                  {formatCurrency(amount * quantity, item.vendorPrice?.currency)}
                </span>
                <button
                  type="button"
                  onClick={() => onRemove(item.vendorCatalogId)}
                  className="shrink-0 text-slate-400 transition hover:text-red-600"
                  aria-label="Remove item"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}

export default SaleCart;
